import React, { Component } from 'react';
import { PreviousButton } from '../components/PreviousButton';
import { LenderRow } from '../components/LenderRow';
import { JointSvg } from '../svg/JointSvg';
import { HomeSvg } from '../svg/HomeSvg';

interface IProps {
    gtmEvent(): void;
    nextStep(s: string): void;
    prevStep(): void;
    coverFor?: "" | "mortgage" | "mortgage / family";
    updateLead(props: any): void;
}

interface IState {
}


export class CoverFor extends Component<IProps, IState> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>Excellent, now about your insurance</h1>
                <h2 className='l'>What would you would like <span className='doddltext'>cover</span> for?</h2>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className='boxty big' onClick={() => {this.props.updateLead({coverFor: 'mortgage'}); this.props.nextStep('mortgage')}}>
                                <div>
                                    <div><HomeSvg/></div>
                                    <div><span className='b'>Mortgage</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='boxty big' onClick={() => {this.props.updateLead({coverFor: 'mortgage / family'}); this.props.nextStep('mortgage / family')}}>
                                <div>
                                    <div><JointSvg /></div>
                                    <div><span className='b'>Mortgage and Family</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
